export const COMMUNITY_AUDIT_TYPE = {
  WEBSITE_MISSING: 10,
  WEBSITE_UNREACHABLE: 11,
  WEBSITE_DECORATED_URL: 12,
  WEBSITE_MISMATCH: 13,
  WEBSITE_INVALID: 14,
};

export const COMMUNITY_AUDIT_TYPE_LABEL = {
  [COMMUNITY_AUDIT_TYPE.WEBSITE_MISSING]: 'Website Missing',
  [COMMUNITY_AUDIT_TYPE.WEBSITE_UNREACHABLE]: 'Website Unreachable',
  [COMMUNITY_AUDIT_TYPE.WEBSITE_DECORATED_URL]: 'Website Decorated URL',
  [COMMUNITY_AUDIT_TYPE.WEBSITE_MISMATCH]: 'Website Mismatch',
  [COMMUNITY_AUDIT_TYPE.WEBSITE_INVALID]: 'Website Invalid',
};

export const COMMUNITY_AUDIT_STATUS = {
  OPEN: 10,
  RESOLVED: 20,
  IGNORED: 30,
};

export const COMMUNITY_AUDIT_STATUS_LABEL = {
  [COMMUNITY_AUDIT_STATUS.OPEN]: 'Open',
  [COMMUNITY_AUDIT_STATUS.RESOLVED]: 'Resolved',
  [COMMUNITY_AUDIT_STATUS.IGNORED]: 'Ignored',
};
